import React from 'react'
import './Footer.css'
// import footerLogo from '../../Assets/logos/footer-logo.png';
import footerLogo from '../../Assets/logo1.svg';
import PrimeryButton from '../../ControlledComponents/PrimeryButton/PrimeryButton';
import InputField from '../../ControlledComponents/InputField/InputField';
import { FaFacebookF } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa6";
// import { FaTwitter } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { FaVimeoV } from "react-icons/fa";
import { FaRegCopyright } from "react-icons/fa6";
import { FaTiktok } from "react-icons/fa6";
import { FaXTwitter } from "react-icons/fa6";
import compLogo from "../../Assets/3mean.png"
import { useTranslation } from "react-i18next";


const Footer = () => {
    const { t ,i18n} = useTranslation();
    const footerNav = [
        {
            name: t('footer.helpcenter'),
            links: [
                { title: t('footer.links.home'), link: '/' },
                { title: t('footer.links.about'), link: '/about-us' },
                { title: t('footer.links.portfolio'), link: '/our-projects' },
                { title: t('footer.links.services'), link: '/services' },
                { title: t('footer.links.contact'), link: '/contact-us' },
            ]
        },
    ];
    const footerSocialIcons = [
        { link: 'https://www.facebook.com/profile.php?id=61574574331628', icon: <FaFacebookF size={20} /> },
        { link: 'https://www.instagram.com/thefilmarz', icon: <FaInstagram size={20} /> },
        { link: 'https://www.tiktok.com/@thefilmarz?lang=en', icon: <FaTiktok size={20} /> },
        { link: 'https://x.com/ArzFilm5785', icon: <FaXTwitter size={20} /> },
        { link: 'https://www.linkedin.com/in/the-filmarz-42b17a358/', icon: <FaLinkedinIn size={20} /> },
        { link: 'https://www.youtube.com/@FilmarzProd', icon: <FaYoutube size={20} /> },
        { link: 'https://vimeo.com/user237514222', icon: <FaVimeoV size={20} /> }
    ]
    return (
        <>
            <div className='footer-main-container'>
                <div className='footer-first-section'>
                    <div className='footer-signup'>
                        <div className='footer-logo-and-company-name'>
                            <img src={footerLogo} alt='footer-logo' />
                            {/* <div className='footer-company-name'>
                                <p>art</p>
                                <p>production</p>
                                <p>video production</p>
                            </div> */}
                        </div>
                        <div className='signup-for-newsletter'>
                            <span>
                                <h3>{t("contact.title")}</h3>
                                <p>{t("contact.newsletter")}</p>
                            </span>
                            <div className='signup-for-newsletter-field'>
                                <InputField
                                    type={'text'}
                                    textAlign={'start'}
                                    placeholder={t("contact.email")}
                                    width={'290px'} height={'50px'}
                                    borderRadius={'10px'}
                                    fontSize={'17px'}
                                    lineHeight={'25px'}
                                    fontWeight={'500'}
                                    color={'#fff'}
                                    backgroundColor={"transparent"}
                                    padding={"0 10px"}
                                />
                                <PrimeryButton
                                    text={t("contact.signup")}
                                    width={'148px'}
                                    height={'50px'}
                                    fontSize={'17px'}
                                    lineHeight={'25px'}
                                    fontWeight={'500'}
                                    color={'#fff'}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='footer-right-section'>
                        {footerNav.map((items, index) => (
                            <div key={index} className='footer-services-section'>
                                <h3>{items.name}</h3>

                                <div className='footer-nav-links'>
                                    {items.links.map((link, index) => (
                                        <a key={index} href={link.link}>{link.title}</a>
                                    ))}
                                </div>
                            </div>
                        ))}

                        <div className='footer-get-in-touch'>
                            <h3>{t("contact.getintouch")}</h3>
                            <div className='footer-contact-details'>
                                <a href='tel:+90 552 225 45 55'>+90 552 225 45 55</a>
                                <a href='mailto:info@filmarz.com'>info@filmarz.com</a>
                                <a href=''>{t("contact.location1")} <br />
                                    {t("contact.location2")}
                                </a>
                                <p className='footer-follow'>{t("contact.followus")}</p>
                                <div className='footer-icons'>
                                    {footerSocialIcons.map((items, index) => (
                                        <a key={index} href={items.link}>{items.icon}</a>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='footer-copy-rights-section'>
                    
                 
                    <div className='footer-copy-right-section'>
                        <a href='#'>{t("contact.terms")}</a> |
                        <p>{t("contact.privacy")}</p>
                    </div>
                    <div className='footer-copy-left-section'>
                        <FaRegCopyright size={10} />
                        <p>{t("contact.rights")}</p>
                    </div>
                    <div onClick={()=>{
                        window.open("https://3meanlimited.com", "_blank")
                    }} className='designerManaged'>
                        <div className="brandLogo">
                            <img src={compLogo} alt="" srcset="" />
                        </div>
                        <div className="company_name">
                            <p>Designed & Managed by</p>
                            <h4>3 Mean Pvt Ltd</h4>
                        </div>
                    </div>
                </div>
            </div>
            <div className='mobile-footer'>
                <div className='mobile-footer-company-nameand-logo'>
                    <img src={footerLogo} alt='footer logo' />
                    {/* <div className='footer-web-name'>
                        <h3>art</h3>
                        <h3>production</h3>
                        <h3>video production</h3>
                    </div> */}
                </div>
                <div className='mobile-footer-follow-us'>
                    <h3>{t("contact.followus")}</h3>
                    <div className='footer-icons'>
                        {footerSocialIcons.map((items, index) => (
                            <a key={index} href={items.link}>{items.icon}</a>
                        ))}
                    </div>
                </div>
                <div className='mobile-footer-help-and-get-in-touch-section'>
                    <div className='footer-help-sec-nav'>
                        {footerNav.map((items, index) => (
                            <div key={index} className='footer-hel-sec-nav-items'>
                                <h3>{items.name}</h3>
                                <div className='footer-nav'>
                                    {items.links.map((items, index) => (
                                        <a key={index} href={items.link}>
                                            {items.title}
                                        </a>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className='mobile-footer-get-in-touch'>
                        <h3>{t("contact.getintouch")}</h3>
                        <div className='mobile-footer-get-in-touch-items'>
                            <a href='tel:+90 552 225 45 55'>+90 552 225 45 55</a>
                            <a href='mailto:info@filmarz.com'>info@filmarz.com</a>
                            <a href=''>{t("contact.location1")} <br />
                                    {t("contact.location2")}
                                </a>
                            {/* <a href='#'> +1 (724) 246-4538 </a> */}
                        </div>
                    </div>
                </div>
                <div className='mobile-footer-newsletter-and-rights'>
                    <h3>{t("contact.title")} <span>{t("contact.newsletter")}</span></h3>
                    <div className='mobile-footer-inputs'>
                        <input type='text' placeholder={t("contact.email")} />
                        <button>{t("contact.signup")}</button>
                    </div>
                    <p className='mobile-footer-copy-rights'>{t("contact.rights")}</p>
                    <div className='mobile-footer-policy'>
                        <p>{t("contact.terms")}</p>
                        <p>{t("contact.privacy")}</p>
                    </div>
                    <div onClick={()=>{
                        window.open("https://3meanlimited.com", "_blank")
                    }} className='designerManaged'>
                        <div className="brandLogo">
                            <img src={compLogo} alt="" srcset="" />
                        </div>
                        <div className="company_name">
                            <p>Designed & Managed by</p>
                            <h4>3 Mean Pvt Ltd</h4>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Footer
